import React, { useRef } from 'react';
import { Dropdown as TdsDropdown, FormItem } from '@tesla/react-tds/global';
import useFormField from '../../hooks/useFormField';

export default function Select({
  children,
  overlayClassName,
  options,
  className,
  multiple,
  id,
  label,
  ...props
}) {
  const { defaultHandler, formFieldContext, render, userProps, formFieldRef } = useFormField(props);

  const ref = useRef();

  const getValue = () => {
    const selected = Array.from(ref.current)
      .filter((option) => option.selected)
      .map((option) => option.value);

    return multiple ? selected : selected[0] || '';
  };

  const handlerWrapper = {
    ...defaultHandler,
    onChange: () => {
      formFieldContext.setValue(getValue());
    },
  };

  return render(
    <FormItem
      error={formFieldContext.$showError}
      errorLabel={formFieldContext.error}
      id={defaultHandler.id}
      label={label}
    >
      <div className={`tds-select ${overlayClassName || ''}`}>
        <select
          id={id}
          ref={ref}
          multiple={multiple}
          className={`tds-select-input ${className || ''}`}
          {...handlerWrapper}
          value={formFieldContext.value || (multiple ? [] : '')}
          {...userProps}
        >
          {options
            ? options.map((option) => (
                <option key={option.value} value={option.value} disabled={option.disabled}>
                  {option.label}
                </option>
              ))
            : children}
        </select>
        <i className="tds-icon tds-icon-arrow-down tds-select-arrow" />
      </div>
    </FormItem>
  );
}
